var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "search",
          attrs: { model: _vm.search, "status-icon": "" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { rules: _vm.searchRules.criteria, prop: "criteria" } },
            [
              _vm.searching
                ? _c("el-input", {
                    staticClass: "nav-search",
                    attrs: {
                      size: "medium",
                      placeholder: _vm.searchingPlaceholder,
                      "prefix-icon": "el-icon-loading",
                    },
                  })
                : _c("el-input", {
                    staticClass: "nav-search",
                    attrs: {
                      size: "medium",
                      type: "text",
                      placeholder:
                        "Search by e-mail, mac address, serial number, order id or PLC uuid/gid",
                      "prefix-icon": "el-icon-search",
                      "auto-complete": "on",
                    },
                    model: {
                      value: _vm.search.criteria,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.search,
                          "criteria",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "search.criteria",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.openProfileCreatorModal
        ? _c("ProfileCreator", {
            attrs: {
              "device-id": _vm.search.criteria,
              open: _vm.openProfileCreatorModal,
            },
            on: {
              "update:open": function ($event) {
                _vm.openProfileCreatorModal = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.openDeviceSelectorModal
        ? _c("DeviceSelector", {
            attrs: {
              devices: _vm.deviceMatches,
              profile: _vm.deviceProfile,
              open: _vm.openDeviceSelectorModal,
            },
            on: {
              "update:open": function ($event) {
                _vm.openDeviceSelectorModal = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.result
        ? _c("RingSolutionsRedirectDialog", {
            attrs: {
              device: _vm.result,
              open: _vm.openRedirectToRingSolutions,
            },
            on: {
              "update:open": function ($event) {
                _vm.openRedirectToRingSolutions = $event
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }